import { Component, OnInit } from '@angular/core';
import {DelegationLibraryConstants} from '../delegation-library-constants'
import { DelegationService } from '../../delegate-slider/services/delegation.service';
import { LabelConstants } from '../../shared/constants/label-constants';
import { ActivatedRoute } from '@angular/router';
import { UsersService } from '../../shared/services/users.service';

@Component({
  selector: 'app-delegation-library',
  templateUrl: './delegation-library.component.html',
  styleUrls: ['./delegation-library.component.scss']
})
export class DelegationLibraryComponent implements OnInit {

  isDelegateSliderOpen = false;
  topBarTitle:string = DelegationLibraryConstants.DelegationLibraryTitle;
  addDelegationTitle:string =  DelegationLibraryConstants.AddDelegationButonTitle;
  isScreenAccessible : boolean = true;
  errorMessage !: string;
  activeIndex: number = 0;
  activeTab : string = DelegationLibraryConstants.TabMyDelegations;

  constructor(    private delegationService: DelegationService, private router: ActivatedRoute, private userService: UsersService    ) { }

  ngOnInit(): void {
    this.router.queryParams.subscribe((queryParams:any) => {
      this.activeTab = queryParams.activeTab;
      if (this.activeTab === DelegationLibraryConstants.TabDelegatedToMe) {
        this.activeIndex = 1;
      } else {
        this.activeIndex = 0;
      }
     }
    );
    this.delegationService.checkAccessibility().subscribe({
      error: (err) => {
        if(err.status === LabelConstants.Forbidden_StatusCode){
          this.errorMessage=err.error.detail;
        }
         this.isScreenAccessible = false;
      },
    })
  }

  addDelegation(){
    this.isDelegateSliderOpen = !this.isDelegateSliderOpen;
  }

  closeDelegateSlider(isSliderActive : boolean){
    this.isDelegateSliderOpen = isSliderActive;
  }

  ngOnDestroy(): void {
    this.userService.clearDelegateUserCache();
  }

}
